import Vue from 'vue'

export function showSuccess(message) {
  Vue.toasted.show(message, {
    duration: '6000',
    type: 'success',
  })
}

export function showError(message) {
  Vue.toasted.show(message, {
    type: 'error',
    duration: '60000',
    position: 'top-center',
    action: [
      {
        text: 'Close',
        onClick: (e, toastObject) => {
          toastObject.goAway(0)
        },
      },
    ],
  })
}

export function showInfo(message) {
  Vue.toasted.show(message, { duration: '6000', type: 'info' })
}
